<div class="login-wrapper">
  <div class="radius-8 border-DB min-h-500 mt-20">
    <ng-content></ng-content>
  </div>
  <div class="div-footer w-100 text-center mt-30 pb-20">
    <ul class="flex justify-content-between px-40">
      <li
        *ngFor="let item of footer; index as i"
        class="inline-block mx-8 w-33">
        <a class="color-psr-disabled-color block f13 n-underline">{{
          item.name | translate
        }}</a>
      </li>
    </ul>
  </div>
</div>
